let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("83Qhe")).then(() => parcelRequire('aR11F'));